export default "__VITE_ASSET__3dbca3b5__"